import React from 'react'
import PropTypes from 'prop-types'
import {values} from 'lodash'
import Flyout from './Flyout'
import {FlyoutPivot} from './FlyoutPivot'
import {FlyoutPosition} from './FlyoutPosition'
import {FlyoutOverflowHandling} from './FlyoutOverflowHandling'

const findParentWithClassName = (element, className) => {
  let current = element
  while (current) {
    if (current.className && current.className.includes(className)) {
      return current
    }
    current = current.parentNode
  }
  return current
}

export default class FlyoutAnchor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      flyoutOpen: false,
      boundingRect: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      flyoutBoundsRect: {
        top: 0,
        left: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
      },
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.flyoutOpen && prevProps.openSync && !this.props.openSync) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        flyoutOpen: false,
      })
    } else if (!this.state.flyoutOpen && !prevProps.openSync && this.props.openSync) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        flyoutOpen: true,
      })
    }
  }

  openFlyout = evt => {
    const {flyoutVisibilityChanged, boundingElementClass, deactivated, stayOpenOnAnchorClick} = this.props

    if (deactivated) return
    const {flyoutOpen} = this.state

    if (boundingElementClass) {
      const boundsElement = findParentWithClassName(evt.target, boundingElementClass)
      if (boundsElement) {
        this.setState({
          flyoutBoundsRect: boundsElement.getBoundingClientRect(),
        })
      }
    }
    const boundingRect = this.wrapperRef.getBoundingClientRect()
    const openFlyout = !flyoutOpen || stayOpenOnAnchorClick
    this.setState({
      boundingRect,
      flyoutOpen: openFlyout,
    })
    if (flyoutVisibilityChanged) {
      flyoutVisibilityChanged(openFlyout)
    }
  }

  onFlyoutClosed = () => {
    const {flyoutVisibilityChanged} = this.props
    this.setState({
      flyoutOpen: false,
    })
    if (flyoutVisibilityChanged) {
      flyoutVisibilityChanged(false)
    }
  }

  flyoutProps = () => {
    const {
      flyoutPosition,
      flyoutPivot,
      flyoutDistance,
      closeEventName,
      borderColor,
      backgroundColor,
      showArrow,
      startWidth,
      startHeight,
      overflowHandling,
      stayOpenOnOutsideClick,
    } = this.props
    const {flyoutOpen, boundingRect, flyoutBoundsRect} = this.state
    return {
      position: flyoutPosition,
      pivot: flyoutPivot,
      open: flyoutOpen,
      anchorRect: boundingRect,
      closed: this.onFlyoutClosed,
      bounds: flyoutBoundsRect,
      flyoutDistance,
      closeEventName,
      borderColor,
      backgroundColor,
      showArrow,
      startWidth,
      startHeight,
      overflowHandling,
      anchorRef: this.wrapperRef,
      stayOpenOnOutsideClick,
    }
  }

  render() {
    const {children, flyoutContent, openSync, deactivated} = this.props
    const {flyoutOpen} = this.state
    return (
      <div className={`FlyoutAnchor ${deactivated && 'FlyoutAnchor--deactivated'}`}>
        <div
          tabIndex={0}
          role="button"
          onKeyPress={() => {}}
          onClick={this.openFlyout}
          ref={node => {
            this.wrapperRef = node
          }}>
          {children}
        </div>
        {flyoutOpen && openSync && <Flyout {...this.flyoutProps()}>{flyoutContent}</Flyout>}
      </div>
    )
  }
}

FlyoutAnchor.defaultProps = {
  flyoutPosition: FlyoutPosition.right,
  flyoutPivot: FlyoutPivot.start,
  openSync: true,
  borderColor: '#eaeaea',
  backgroundColor: 'white',
  showArrow: true,
  stayOpenOnAnchorClick: false,
}

FlyoutAnchor.propTypes = {
  flyoutPosition: PropTypes.oneOf(values(FlyoutPosition)),
  flyoutPivot: PropTypes.oneOf(values(FlyoutPivot)),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.node]).isRequired,
  flyoutContent: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.node]),
  openSync: PropTypes.bool,
  flyoutVisibilityChanged: PropTypes.func,
  boundingElementClass: PropTypes.string,
  deactivated: PropTypes.bool,
  flyoutDistance: PropTypes.number,
  closeEventName: PropTypes.string,
  borderColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  showArrow: PropTypes.bool,
  startWidth: PropTypes.number,
  startHeight: PropTypes.number,
  overflowHandling: PropTypes.oneOf(values(FlyoutOverflowHandling)),
  stayOpenOnAnchorClick: PropTypes.bool,
  stayOpenOnOutsideClick: PropTypes.bool,
}
